import React, { useEffect, useState } from 'react';

export default function TimeRestriction({ text, modalState, onClose }) {
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    setIsOpen(modalState);
  }, [modalState]);

  return (
    isOpen && (
      <div
        style={{
          display: 'flex',
          minHeight: '100vh',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.5)', // semi-transparent overlay
          padding: '16px',
        }}>
        <div
          style={{
            width: '100%',
            maxWidth: '400px',
            backgroundColor: '#ffffff', // white background
            borderRadius: '8px',
            padding: '24px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            textAlign: 'center',
          }}>
          <h2
            style={{
              fontSize: '24px',
              fontWeight: 'bold',
              color: '#333333',
              marginBottom: '16px',
            }}>
            Booking Unavailable
          </h2>
          <p
            style={{
              fontSize: '16px',
              color: '#555555',
              marginBottom: '24px',
              lineHeight: '1.5',
            }}>
            This booking is scheduled for a future time. There is {text} remaining until it becomes eligible for
            completion. Please try again later.
          </p>
          <button
            onClick={onClose}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '100%',
              padding: '10px 20px',
              fontSize: '16px',
              fontWeight: '500',
              color: '#ffffff',
              backgroundColor: '#007BFF',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer',
              transition: 'background-color 0.2s',
              outline: 'none',
            }}
            onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#0056b3')}
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#007BFF')}>
            Close
          </button>
        </div>
      </div>
    )
  );
}
